import { Box, LinearProgress, Tooltip, Typography } from "@mui/material";
import { memo } from "react";

import { IDashboardGenerateExecution } from "../../../models/dashboard-generate-execution";

interface IExecutionProgressProps {
  execution: IDashboardGenerateExecution;
}

const ExecutionProgress = ({ execution }: IExecutionProgressProps) => {
  const color =
    execution.failedGenerates > 0
      ? "warning"
      : execution.status === "finished"
        ? "success"
        : "primary";

  const progress = Math.min(execution.progress, 100);

  const percent = Math.floor(progress);

  return (
    <Tooltip
      title={`${execution.reducedGenerates}/${execution.totalGenerates}`}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}
      >
        <LinearProgress
          variant="determinate"
          color={color}
          value={progress}
          sx={{ flex: 1, height: 6, borderRadius: 3 }}
        />
        <Typography
          variant="caption"
          sx={{ whiteSpace: "nowrap", minWidth: 32, textAlign: "right" }}
        >
          {percent}%
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default memo(ExecutionProgress);
